import { downloadAllQueryCSV } from "@/helpers/apis";
import { DownloadTable } from "@/components/downloadTable";
import { useAllQueriesFilters } from "./useAllQueriesFilters";
import { QueriesTracking } from "@/lib/tracking/queries";

interface AllQueriesDownloadProps {
  disabled?: boolean;
  queryCount?: number;
}

const AllQueriesDownload = ({ disabled, queryCount }: AllQueriesDownloadProps) => {
  const { filterParams } = useAllQueriesFilters({});

  const handleDownload = async () => {
    QueriesTracking.downloaded(queryCount ?? 0);
    await downloadAllQueryCSV(filterParams);
  };

  return (
    <DownloadTable
      handleDownload={handleDownload}
      buttonProps={{ disabled, variant: "outline" }}
    />
  );
};

export default AllQueriesDownload;
